(function(){
    angular.module('tmx-app').factory('ProcessDesignerService', ['tmxResource',
        function(tmxResource){

            var processdesigner = tmxResource("Product");

  
            processdesigner.gridColumn = [
                {
                    hidden:true,
                    field: "WorkflowSchemeCode",
                    title: "",
                    type: "text",
      //template: "<md-button class='tmx-primary-text' ng-click='ProcessDesignerCtrl.clickEdit(dataItem)'> \{\{ProcessDesignerCtrl.formatUserName(dataItem)\}\} </md-button>",
     // headerTemplate:"<span><i class='fa fa-filter'></i></span>",
                    groupHeaderTemplate: "<md-button class='tmx-primary-text' ng-disabled='!ProcessDesignerCtrl.editPermission' ng-click='ProcessDesignerCtrl.clickEdit(dataItem)' ng-bind='dataItem.value'> </md-button>"
      // ng-if='ProcessDesignerCtrl.isFiltered(\"WorkflowSchemeCode\")'    <md-tooltip md-direction='top'>#=WorkflowSchemeCode#</md-tooltip> 
     
                }, 
                {
                    field: "ProductName",
                    title: "Product Name",
                    type: "text",
      // data: processdesigner.desigs,
      // isNumber: true,
                    headerTemplate:"<span>Product Name<i class='fa fa-filter'></i></span>"
                }, 
                {
                    field: "ProductCode",
                    title: "Product Code",
                    type: "numeric",
       // template: "{{ProcessDesignerCtrl.formatPhoneNumber(dataItem)}}",
                    headerTemplate:"<span>Product Code<i class='fa fa-filter'></i></span>"
      // ng-class=\"{ ProcessDesignerCtrl.isFiltered('ProductId')}\"
                }
            ];

            processdesigner.columns = angular.copy(processdesigner.gridColumn);

            return processdesigner;

// }]);
        }])
})();